module.exports = __webpack_public_path__ + "static/media/icon-download.ddae2403.webp";